const transitionTimingFunction = {
    name: "transition-timing-function",
    path: "/transition-timing-function",
    title: "transition-timing-function",
    description: "Utilities for controlling the timing function of transitions.",
    value: {
        'transition-timing-function': {
            'ease-linear': 'linear',
            'ease-in': 'cubic-bezier(0.4, 0, 1, 1)',
            'ease-out': 'cubic-bezier(0, 0, 0.2, 1)',
            'ease-in-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
            'ease-initial': 'initial',
            'ease-[<value>]': '<value>',
        },
    },
    exampleData: [
        {
            example: {
                code: `<button class="transition-all duration-500 ease-linear bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
  Linear
</button>
<button class="transition-all duration-500 ease-in bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Ease In
</button>
<button class="transition-all duration-500 ease-out bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Ease Out
</button>
<button class="transition-all duration-500 ease-in-out bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Ease In Out
</button>
<button class="transition-all duration-500 ease-initial bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Initial
</button>`
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">ease-linear</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">ease-in</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">ease-out</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">ease-in-out</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">ease-initial</code> to control the transition timing function.
      </p>
      <div class="flex gap-4">
        <button class="transition-all hover:scale-125 duration-500 ease-linear bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Linear
        </button>
        <button class="transition-all hover:scale-125 duration-500 ease-in bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Ease In
        </button>
        <button class="transition-all hover:scale-125 duration-500 ease-out bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Ease Out
        </button>
        <button class="transition-all hover:scale-125 duration-500 ease-in-out bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Ease In Out
        </button>
        <button class="transition-all hover:scale-125 duration-500 ease-initial bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Initial
        </button>
        <button class="transition-all hover:scale-125 duration-500 ease-[cubic-bezier(0.95,0.05,0.795,0.035)] bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Custom
        </button>   
      </div>
      `
        }
    ]
};

export default transitionTimingFunction;
<div className="sr-only duration-500 ease-linear ease-in ease-out ease-in-out ease-initial ease-[cubic-bezier(0.95,0.05,0.795,0.035)]"></div>